import React from 'react';
import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import { Send } from 'lucide-react';

const Container = styled.div`
  width: 100%;
  height: 100%;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const FormCard = styled(motion.div)`
  width: 320px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
  padding: 24px;
  border: 1px solid #e5e7eb;
`;

const Title = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 8px;
  text-align: center;
`;

const Subtitle = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 24px;
  text-align: center;
`;

const Field = styled.div`
  margin-bottom: 16px;
`;

const Label = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 6px;
`;

const Input = styled(motion.div)`
  height: 40px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  font-size: 14px;
  color: #111827;
  overflow: hidden;
`;

const Button = styled(motion.button)`
  width: 100%;
  height: 40px;
  background: #111827;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  margin-top: 8px;
`;

const TypingText = ({ text, delay }: { text: string; delay: number }) => {
    return (
        <motion.span
            initial={{ width: 0 }}
            animate={{ width: '100%' }}
            transition={{ duration: 1, delay, ease: "linear" }}
            style={{ whiteSpace: 'nowrap', overflow: 'hidden', display: 'inline-block' }}
        >
            {text}
        </motion.span>
    );
};

const LeadGenVisual: React.FC = () => {
    return (
        <Container>
            <FormCard
                initial={{ scale: 0.9, opacity: 0 }}
                whileInView={{ scale: 1, opacity: 1 }}
                viewport={{ once: true }}
            >
                <Title>Get your free demo</Title>
                <Subtitle>Leave your details and we'll be in touch.</Subtitle>

                <Field>
                    <Label>Full Name</Label>
                    <Input>
                        <TypingText text="John Doe" delay={0.5} />
                    </Input>
                </Field>

                <Field>
                    <Label>Email Address</Label>
                    <Input>
                        <TypingText text="john@company.com" delay={1.8} />
                    </Input>
                </Field>

                <Button
                    initial={{ opacity: 0.5 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 3 }}
                    whileHover={{ scale: 1.02 }}
                >
                    Submit Request <Send size={14} />
                </Button>
            </FormCard>
        </Container>
    );
};

export default LeadGenVisual;
